import { holdingsAdditionalDetails } from "../../apis";
import { getFixedFloatedValue, getFormattedNumbers, getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";

/**AMEER */

/*what is type of isin */

async function _getHoldingsAdditionalDetails(objLoginSession, activeHoldings, isin) {
    try {
        const objresp = await holdingsAdditionalDetails({ user_id: objLoginSession?.data?.user_id, groupId: objLoginSession?.data?.others?.groupId, isin: isin, });
        let arrHoldingsDetails = objresp?.data?.result?.map(item => ({ ...item, sCurRecvPledge: 0, sRecvPledge: 0 }));

        if (activeHoldings?.length > 0) {
            const nIndexOfHolding = activeHoldings.findIndex(obj => obj.isin === isin);
            activeHoldings[nIndexOfHolding].additionalDetails = arrHoldingsDetails;
            return { status: true, message: "SUCCESS", data: activeHoldings };
        } else { }
    } catch (error) {
        return { status: false, message: "FAILURE", error };
    }
}


async function _updateHoldings(objHoldingsData) {
    try {
        const equityHoldings = objHoldingsData?.data?.result.filter(elem => elem.sSeries === 'EQ');
        const mutualFundsHoldings = objHoldingsData?.data?.result.filter(elem => elem.sSeries === 'MF');
        const holdingTypes = [{ id: 1, name: 'EQUITY', data: [...equityHoldings].map(obj => ({ ...obj, ltp: '' })) }, { id: 2, name: 'Mutual Funds', data: [...mutualFundsHoldings] }];

        return { status: true, message: "SUCCESS", data: holdingTypes };

    } catch (error) {

        return { status: false, message: "FAILURE", error };

    }
}

function _getEquityHoldingScrips(objMyHoldingWatchlist) {
    try {
        const arrEquityHoldingSCrips = objMyHoldingWatchlist?.data?.result.filter(elem => elem.sSeries !== 'MF');

        return { status: true, message: "SUCCESS", data: arrEquityHoldingSCrips };

    } catch (error) {

        return { status: false, message: "FAILURE", error };

    }
}


function _getColor(value) {
    if (value === 0) { return '#ebebeb'; }
    else if (value >= 2.00) { return '#2e7b30'; }
    else if (value >= 1.00) { return '#419644'; }
    else if (value > 0.00) { return '#4caf50'; }
    else if (value >= -1.00) { return '#ff0000'; }
    else if (value >= -2.00) { return '#b70404'; }
    else if (value >= -3.00) { return '#8a0000'; }
    else if (value < 3.00) { return '#4a2525'; }
}

const _holdingsConversion = (holdingsScrips, obj, temp, nFormat) => {
    holdingsScrips?.forEach(holdingDataItem => {
        holdingDataItem.detail = '';
        holdingDataItem.ISIN = holdingDataItem.ISIN.trim();
        holdingDataItem.qty = holdingDataItem.TOTALFREEQUANTITY;
        holdingDataItem.ltp = 0.00;
        holdingDataItem.ltpDisplay = "0.00";
        holdingDataItem.closePrice = 0.00;
        holdingDataItem.PandL = 0.00;
        holdingDataItem.TodaysPandL = 0.00;
        holdingDataItem.CMV = 0.00;
        holdingDataItem.PrevCloseValue = 0.00;
        //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings keys Updated:Start
        holdingDataItem.InvestedValue = (holdingDataItem.nBuyAvgPrice && holdingDataItem?.nNormal_MarketAllowed === 1) ? (parseFloat(holdingDataItem.nBuyAvgPrice) * parseInt(holdingDataItem.TOTALFREEQUANTITY)).toFixed(2) : (0).toFixed(nFormat);
        //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings keys Updated:End
        holdingDataItem.InvestedValueDisplay = getFormattedNumbers(holdingDataItem.InvestedValue);
        holdingDataItem.nBuyAvgPriceDisplay = getFormattedNumbers(holdingDataItem.nBuyAvgPrice);
        holdingDataItem.perPandL = 0.00;
        holdingDataItem.perTodaysPandL = 0.00;
        holdingDataItem.NetChangeInRs = 0.00;
        holdingDataItem.PercNetChange = 0.00;
        holdingDataItem.sector = '';
        holdingDataItem.segmentIdToken = getMktSegIdFromMappedMktSegId(holdingDataItem?.nMarketSegmentId) + '_' + holdingDataItem?.nToken; //vaibhav Singh:23-02-24: MappedMktsegId converted to  segid: Start
        holdingDataItem.LTPTrend = '';
        holdingDataItem.arrowTrend = '';
        holdingDataItem.additionalDetails = holdingDataItem.additionalDetails;
        holdingDataItem.ScripData = holdingDataItem.ScripData;
        //Vaibhav Singh: BT-107421: 06-02-24: Added Validation in calculateions updated: Start 
        temp.investedValue = getFixedFloatedValue(holdingsScrips?.reduce((acc, obj) => { return acc + parseFloat(obj?.InvestedValue); }, 0), nFormat);
        //Vaibhav Singh: BT-107421: 06-02-24: Added Validation in calculateions updated: End
        const key = `${getMktSegIdFromMappedMktSegId(holdingDataItem?.nMarketSegmentId)}_${holdingDataItem?.nToken}`; //vaibhav Singh:23-02-24: MappedMktsegId converted to  segid: Start
        obj[`${key}`] = holdingDataItem;
    });
};

const _percentChange = (params) => {
    if (params.value != null) {
        return params?.value + ' %';
    } else {
        return '';
    }
};

const _holdingsFilters = (data, holdingsData) => {
    let arrHoldings = [];
    if (Object?.keys(data)?.length > 0) {
        if (data?.alphabetically === 'a-z') {
            arrHoldings = holdingsData?.slice().sort((a, b) => a.sSymbol.localeCompare(b.sSymbol));
        } else if (data?.alphabetically === 'z-a') {
            arrHoldings = holdingsData?.slice().sort((a, b) => b.sSymbol.localeCompare(a.sSymbol));
        } else if (data?.CMV === 'low_high') {
            arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(a.CMV) - parseFloat(b.CMV));
        } else if (data?.CMV === 'high_low') {
            arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(b.CMV) - parseFloat(a.CMV));
        } else if (data?.DaysPl === 'low_high') {
            if (data?.DaysPlMin && data?.DaysPlMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) >= parseFloat(data?.DaysPlMin) && parseFloat(x?.TodaysPandL) <= parseFloat(data?.DaysPlMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(a.TodaysPandL) - parseFloat(b.TodaysPandL));
            }
            else if (data?.DaysPlMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) >= parseFloat(data?.DaysPlMin));
            }
            else if (data?.DaysPlMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) <= parseFloat(data?.DaysPlMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(a.TodaysPandL) - parseFloat(b.TodaysPandL));
            }
        } else if (data?.DaysPl === 'high_low') {
            if (data?.DaysPlMin && data?.DaysPlMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) >= parseFloat(data?.DaysPlMin) && parseFloat(x?.TodaysPandL) <= parseFloat(data?.DaysPlMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(b.TodaysPandL) - parseFloat(a.TodaysPandL));
            }
            else if (data?.DaysPlMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) >= parseFloat(data?.DaysPlMin));
            }
            else if (data?.DaysPlMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) <= parseFloat(data?.DaysPlMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(b.TodaysPandL) - parseFloat(a.TodaysPandL));
            }
        } else if (data?.OverallPl === 'low_high') {
            if (data?.overallPlMin && data?.overallPlMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.PandL) >= parseFloat(data?.overallPlMin) && parseFloat(x?.PandL) <= parseFloat(data?.overallPlMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(a.PandL) - parseFloat(b.PandL));
            } else if (data?.overallPlMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.PandL) >= parseFloat(data?.overallPlMin));
            } else if (data?.overallPlMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.PandL) <= parseFloat(data?.overallPlMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(a.PandL) - parseFloat(b.PandL));
            }
        } else if (data?.OverallPl === 'high_low') {
            if (data?.overallPlMin && data?.overallPlMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.PandL) >= parseFloat(data?.overallPlMin) && parseFloat(x?.PandL) <= parseFloat(data?.overallPlMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(b.PandL) - parseFloat(a.PandL));
            }
            else if (data?.overallPlMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.PandL) >= parseFloat(data?.overallPlMin));
            } else if (data?.overallPlMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.PandL) <= parseFloat(data?.overallPlMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(b.PandL) - parseFloat(a.PandL));
            }
        } else if (data?.DaysPlPer === 'low_high') {
            if (data?.DaysPerMin && data?.DaysPerMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) >= parseFloat(data?.DaysPerMin) && parseFloat(x?.perTodaysPandL) <= parseFloat(data?.DaysPerMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(a.perTodaysPandL) - parseFloat(b.perTodaysPandL));
            } else if (data?.DaysPerMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) >= parseFloat(data?.DaysPerMin));
            } else if (data?.DaysPerMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) <= parseFloat(data?.DaysPerMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(a.perTodaysPandL) - parseFloat(b.perTodaysPandL));
            }

        } else if (data?.DaysPlPer === 'high_low') {
            if (data?.DaysPerMin && data?.DaysPerMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) >= parseFloat(data?.DaysPerMin) && parseFloat(x?.perTodaysPandL) <= parseFloat(data?.DaysPerMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(b.perTodaysPandL) - parseFloat(a.perTodaysPandL));
            } else if (data?.DaysPerMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) >= parseFloat(data?.DaysPerMin));
            } else if (data?.DaysPerMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) <= parseFloat(data?.DaysPerMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(b.perTodaysPandL) - parseFloat(a.perTodaysPandL));
            }
        } else if (data?.OverallPlPer === 'low_high') {
            if (data?.overallPerMin && data?.overallPerMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.perPandL) >= parseFloat(data?.overallPerMin) && parseFloat(x?.perPandL) <= parseFloat(data?.overallPerMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(a.perPandL) - parseFloat(b.perPandL));
            } else if (data?.overallPerMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perPandL) >= parseFloat(data?.overallPerMin));
            } else if (data?.overallPerMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perPandL) <= parseFloat(data?.overallPerMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(a.perPandL) - parseFloat(b.perPandL));
            }

        } else if (data?.OverallPlPer === 'high_low') {
            if (data?.overallPerMin && data?.overallPerMax) {
                let arrMinMax = holdingsData?.filter(x => parseFloat(x?.perPandL) >= parseFloat(data?.overallPerMin) && parseFloat(x?.perPandL) <= parseFloat(data?.overallPerMax));
                arrHoldings = arrMinMax?.slice().sort((a, b) => parseFloat(b.perPandL) - parseFloat(a.perPandL));
            } else if (data?.overallPerMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perPandL) >= parseFloat(data?.overallPerMin));
            } else if (data?.overallPerMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perPandL) <= parseFloat(data?.overallPerMax));
            }
            else {
                arrHoldings = holdingsData?.slice().sort((a, b) => parseFloat(b.perPandL) - parseFloat(a.perPandL));
            }

            //Vaibhav Singh: 05-02-24: BT-104814: Commented unused code
        }
        if (arrHoldings?.length === 0) {
            if (data?.DaysPlMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) > parseFloat(data?.DaysPlMin));
            } else if (data?.DaysPlMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.TodaysPandL) < parseFloat(data?.DaysPlMax));
            } else if (data?.overallPlMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.PandL) > parseFloat(data?.overallPlMin));
            } else if (data?.overallPlMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.PandL) < parseFloat(data?.overallPlMax));
            } else if (data?.DaysPerMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) > parseFloat(data?.DaysPerMin));
            } else if (data?.DaysPerMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perTodaysPandL) < parseFloat(data?.DaysPerMax));
            } else if (data?.overallPerMin) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perPandL) > parseFloat(data?.overallPerMin));
            } else if (data?.overallPerMax) {
                arrHoldings = holdingsData?.filter(x => parseFloat(x?.perPandL) < parseFloat(data?.overallPerMax));
            }
        }
    }
    if (arrHoldings?.length > 0) {
        return arrHoldings;
    }
};

export { _getHoldingsAdditionalDetails, _updateHoldings, _getEquityHoldingScrips, _getColor, _holdingsConversion, _percentChange, _holdingsFilters };
